import React from 'react';

export default class GTMDataLayerHack extends React.PureComponent {

  constructor(props) {
    super(props);
    // Setup the data layer used by the tag manager.
    // GTM Migration Event
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ fireGtm: true });
  }

  componentDidMount() {
    const s = 'script';
    const newElement = document.createElement(s);
    const element = document.getElementsByTagName(s)[0];
    newElement.type = 'text/javascript';
    newElement.textContent =
      'var window.dataLayer = window.dataLayer || [];\nwindow.dataLayer.push({ \'fireGtm\': true });';
    element.parentNode.insertBefore(newElement, element);
  }

  render() {
    return null;
  }
}




/** WEBPACK FOOTER **
 ** ./src/GTMDataLayerHack.js
 **/